import { render, staticRenderFns } from "./tenancy-chip.vue?vue&type=template&id=40ea9783&"
import script from "./tenancy-chip.vue?vue&type=script&lang=ts&"
export * from "./tenancy-chip.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Sources\\nothegger.topwm\\Nothegger.TopWM.Warehouse.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40ea9783')) {
      api.createRecord('40ea9783', component.options)
    } else {
      api.reload('40ea9783', component.options)
    }
    module.hot.accept("./tenancy-chip.vue?vue&type=template&id=40ea9783&", function () {
      api.rerender('40ea9783', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/tenants/components/tenancy-chip.vue"
export default component.exports